import { render } from "./PrivateLayout.vue?vue&type=template&id=51f1d888"
import script from "./PrivateLayout.vue?vue&type=script&lang=js"
export * from "./PrivateLayout.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__